import React from 'react'

import { AsyncSelect, Form, Button } from '_zari/core'

import { NuevoClienteModal } from 'sharedComponents/modals'

import * as SocioService from 'services/socio.service'

const Select2ClienteInput = ({ id, disabled, showNewButton, showCheckboxAlias, onChange, onCreate }) => {
  const [mostrarNuevoSocioModal, setMostrarNuevoSocioModal] = React.useState(false)
  const [flagBuscarPorAlias, setFlagBuscarPorAlias] = React.useState(false)

  const defaultDataRef = React.useRef({})

  const loadSociosSelect = React.useCallback(
    (inputValue, resolve) => {
      defaultDataRef.current.numeroDocumento = inputValue

      SocioService.obtenerClientesxBusquedaAsSelect2({
        busqueda: inputValue,
        tipoBusqueda: flagBuscarPorAlias ? 'sobrenombre' : ''
      })
        .then(({ data }) => resolve(data))
        .catch(() => resolve([]))
    },
    [flagBuscarPorAlias]
  )

  const clickMostrarNuevoSocioModalHandler = React.useCallback(() => {
    setMostrarNuevoSocioModal(true)
  }, [])

  const innerOnCreate = React.useCallback(
    creationResult => {
      onCreate(creationResult, () => {
        setMostrarNuevoSocioModal(false)
      })
    },
    [onCreate]
  )

  return (
    <>
      {showNewButton ? (
        <>
          <Form.InputGroup>
            <AsyncSelect selectId={id} loadOptions={loadSociosSelect} onChange={onChange} />
            <Form.InputGroup.Append>
              <Button disabled={disabled} onClick={clickMostrarNuevoSocioModalHandler}>
                &#x2b;
              </Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {showCheckboxAlias && (
            <Form.Checkbox
              checked={flagBuscarPorAlias}
              disabled={disabled}
              id='checkbox-buscarPorAlias'
              name='checkbox-shared-select2-buscarPorAlias'
              label='Buscar por alias'
              onChange={() => setFlagBuscarPorAlias(prev => !prev)}
            />
          )}
        </>
      ) : (
        <>
          <AsyncSelect selectId={id} loadOptions={loadSociosSelect} onChange={onChange} />
          {showCheckboxAlias && (
            <Form.Checkbox
              checked={flagBuscarPorAlias}
              disabled={disabled}
              id='checkbox-buscarPorAlias'
              name='checkbox-shared-select2-buscarPorAlias'
              label='Buscar por alias'
              onClick={() => setFlagBuscarPorAlias(prev => !prev)}
            />
          )}
        </>
      )}
      {mostrarNuevoSocioModal && (
        <NuevoClienteModal
          handleClose={() => setMostrarNuevoSocioModal(false)}
          show={mostrarNuevoSocioModal}
          onCreate={innerOnCreate}
          defaultData={defaultDataRef.current}
        />
      )}
    </>
  )
}

export default React.memo(Select2ClienteInput)
